function Send({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '21'} height=${(dimensions * 6) / 7 || '18'}  viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.00999999 18L21 9L0.00999999 0L0 7L15 9L0 11L0.00999999 18Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Send;
